var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.534,
    height: 23.199,
    viewBox: "0 0 20.534 23.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-522.858 -392.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M542.729,401.336H539.3a.664.664,0,0,0-.469.194l-5.947,5.947a.665.665,0,0,0-.2.469.658.658,0,0,0,.2.468l3.427,3.428a.655.655,0,0,0,.469.193.667.667,0,0,0,.468-.193l5.948-5.949a.657.657,0,0,0,.194-.467V402A.664.664,0,0,0,542.729,401.336Zm-.663,1.325v2.491l-5.284,5.284-2.491-2.49,5.285-5.285Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.769,
    cy: 0.769,
    r: 0.769,
    transform: "translate(539.591 403.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M531.813,411.9V399.505h.989a.6.6,0,0,0,.6-.6v-5.379a.6.6,0,0,0-.6-.6h-7.317a.6.6,0,0,0-.6.6V398.9a.6.6,0,0,0,.6.6h.99v12.39c-1.465.211-3.617.74-3.617,2.025,0,1.742,3.951,2.206,6.286,2.206s6.286-.464,6.286-2.206C535.43,412.647,533.343,412.114,531.813,411.9Zm-5.728-13.59v-4.18H532.2v4.18h-.389v-2.385a.6.6,0,0,0-.6-.6h-4.138a.6.6,0,0,0-.6.6v2.385Zm1.59,8.721V396.521h2.938v10.506Zm2.938,1.2v5.093h-2.938v-5.093Zm-1.469,6.7c-3.272,0-4.947-.74-5.094-.966.055-.115.641-.568,2.425-.848v.807a.6.6,0,0,0,.6.6h4.138a.6.6,0,0,0,.6-.6v-.81a5.561,5.561,0,0,1,2.424.768C534.09,414.187,532.416,414.927,529.144,414.927Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.d3deefe63c3e4d1d42235bd35ab81e87.svg";
export { ForwardRef as ReactComponent };